// tslint:disable:component-selector
import { Component, OnInit, Input, ChangeDetectionStrategy, ViewEncapsulation, HostBinding } from '@angular/core';

@Component({
  selector: 'button[app-scene-button]',
  templateUrl: './scene-button.component.html',
  styleUrls: ['./scene-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class SceneButtonComponent implements OnInit {
  @Input()
  selected = false;

  @Input()
  expandable = false;

  @Input()
  @HostBinding('disabled') disabled: boolean;

  constructor() { }

  ngOnInit() {
  }

}
